import React from 'react';
import {connect} from 'react-redux';

class DeviceName extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        deviceName: React.PropTypes.string,
        onlineState: React.PropTypes.bool,
        openKeyboard: React.PropTypes.func
    };

    render() {
        const {deviceName, msg, onlineState, openKeyboard} = this.props;

        return (
            <div className="table-row">
                <div className="table-cell" style={{width: '55.55%'}}>
                    <div className="boxBtn text-black text-left">
                        <div className="boxBtn-inner">
                            <div className="settings-name">
                                <span className="settings-name-name">{msg.settings.deviceName.title}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="table-cell" style={{width: '22.22%'}}>
                    <div className="boxBtn text-black text-l">
                        <div className="boxBtn-inner">
                            <span>{deviceName}</span>
                        </div>
                    </div>
                </div>
                <div className="table-cell" style={{width: '22.22%'}}>
                    <div className={`boxBtn color-green text-l ${onlineState ? '' : 'disabled'}`}>
                        <div className="boxBtn-inner" onClick={openKeyboard}>
                            <span>{msg.settings.deviceName.change}</span>
                            {!onlineState &&
                                <span>{msg.menu.offlineMode}</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    deviceName: state.device.name,
    onlineState: state.categories.get('onlineState')
}), {})(DeviceName);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/DeviceName.js